import LegalPage from "@/pages/LegalPage";
import { TERMS_MARKDOWN } from "@/content/terms";

export default function Terms() {
  return <LegalPage title="Terms" markdown={TERMS_MARKDOWN} testId="terms-page" />;
}
